import styled from 'styled-components';
import { Colors, FontSize } from '../../assets/GlobalStyle/Variables';

export const ProtocolContainer = styled.div`
  padding: 1.5rem 2rem;
  background: linear-gradient(to bottom, #f8f5fa 0%, #ffffff 100%);
  min-height: calc(100vh - 68px);
`;

export const StyledPageTitle = styled.div`
  background: linear-gradient(135deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    color: ${Colors.white};
    font-size: ${FontSize.title};
    font-weight: 600;
    margin: 0;
    letter-spacing: -0.3px;
  }
`;

export const ProtocolTitleInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 2rem;

  > div {
    color: ${Colors.white};
    font-size: ${FontSize.subTitle};
    font-weight: 500;

    &:first-child {
      font-weight: 600;
    }

    &:last-child {
      text-align: right;
    }
  }
`;

export const TabsCard = styled.div`
  background: ${Colors.white};
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 2rem;
`;
